import { useMemo } from 'react';
import { UseRequestStoreResult } from '@proscom/prostore-react';
import { GraphqlWatchQueryStore } from '@proscom/prostore-apollo';
import { useDocumentSectionsInWelcomePage as useDocumentSections } from '../../../graphql/hooks/useDocumentSections';
import { DocumentSectionType } from '../../../graphql/types';

export function useDocumentSectionsInWelcomePage(): UseRequestStoreResult<
  GraphqlWatchQueryStore<{}, DocumentSectionType[]>
> {
  const documentSectionsQuery = useDocumentSections();

  const filteredSections = useMemo(() => {
    if (!documentSectionsQuery.state.data) return [];
    const sections = documentSectionsQuery.state.data;
    return sections;
  }, [documentSectionsQuery.state.data]);

  return {
    ...documentSectionsQuery,
    state: {
      ...documentSectionsQuery.state,
      data: filteredSections
    }
  };
}
